import React, { useEffect, useState } from "react"
import { Box, CircularProgress } from "@mui/material"

const PrivacyPolicy = () => {
  const [html, setHtml] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const controller = new AbortController()
    const privacyPolicyHtmlUrl = `${process.env.PUBLIC_URL}/privacypolicy.html`

    const loadHtml = async () => {
      try {
        const response = await fetch(privacyPolicyHtmlUrl, { signal: controller.signal })
        const text = await response.text()
        setHtml(text)
      } catch (error) {
        if (error?.name !== "AbortError") {
          // eslint-disable-next-line no-console
          console.error("Failed to load privacy policy HTML", error)
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false)
        }
      }
    }

    loadHtml()

    return () => controller.abort()
  }, [])

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", bgcolor: "background.default" }}>
      <Box sx={{ width: "100%", p: { xs: 2, md: 4 } }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </Box>
    </Box>
  )
}

export default PrivacyPolicy
